/** @format */

import React, { useEffect, useState } from 'react';
import I18n from '../../components/Translate/I18n';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import GridContainer from '../../components/Grid/GridContainer';
import Card from '../../components/Card/Card';
import CardHeader from '../../components/Heading/CardHeaderExt';
import CardIcon from '../../components/Card/CardIcon';
import PermIdentity from '@material-ui/icons/PermIdentity';
import CardBody from '../../components/Card/CardBody';
import GridItem from '../../components/Grid/GridItem';
import { useDispatch } from 'react-redux';
import InputFormRest from '../../components/Form/InputFormRest';
import CardFooter from '../../components/Card/CardFooter';
import Button from '@material-ui/core/Button';
import { UserPermissionGroupAssignment } from './UserPermissionGroupAssignment';
import { PlatformUserDefinedRolesToSendInterface } from '../../interfaces/platform/PlatformUserDefinedRolesInterface';
import TuneIcon from '@material-ui/icons/Tune';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';

export type PlatformUserModifyType = {
    userId?: string | null;
    resellerId?: string | null;
    outputObject?: any;
    savePermissionGroup: (outputObject: PlatformUserDefinedRolesToSendInterface) => void;
    checkedElements: any;
    setCheckedElements: React.Dispatch<any>;
    id?: number | null;
};

export const UserPermissionGroupModify = (props: PlatformUserModifyType): React.ReactElement => {
    const dispatch = useDispatch();
    const savePermissionGroup = props.savePermissionGroup;
    const [outputObject, setOutputObject] = useState<any>({
        mainname: '',
    } as PlatformUserDefinedRolesToSendInterface);

    const [permissionGroupStatus, setPermissionGroupStatus] = useState<any>({});

    const updateCallback = (
        event: React.FormEvent<HTMLInputElement>,
        stateName: string,
        typeField: string,
        typeCallback: string,
        required: boolean,
        vMax: number,
        vMin?: number
    ): void => {
        const tmp = { ...outputObject };
        FormGeneralHelper.validateFormsHook(
            tmp,
            setOutputObject,
            permissionGroupStatus,
            setPermissionGroupStatus,
            event,
            stateName,
            typeField,
            require,
            vMax,
            vMin
        );
    };

    useEffect(() => {
        if (props.outputObject) {
            const tmpOutputObject = {
                ...props.outputObject,
            };
            setOutputObject(tmpOutputObject);
        }
    }, [props.outputObject]);

    return (
        <React.Fragment>
            <Card>
                <CardHeader icon={<TuneIcon />} trans="permission_groups:h.permission_group" />
                <CardBody>
                    {outputObject && (
                        <GridContainer>
                            <GridItem xs={4}>
                                <GridContainer>
                                    <GridItem xs={12}>
                                        <InputFormRest
                                            stateName={'mainname'}
                                            callback={updateCallback}
                                            stateObjectState={permissionGroupStatus.mainname}
                                            typeField={'text'}
                                            displayFieldName={'permission_groups:h.mainname'}
                                            required={true}
                                            value={outputObject?.mainname}
                                            vMin={4}
                                            vMax={64}
                                            typeCallback={'string'}
                                        />
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <InputFormRest
                                            stateName={'ttlToken'}
                                            callback={updateCallback}
                                            stateObjectState={permissionGroupStatus.ttlToken}
                                            typeField={'text'}
                                            displayFieldName={'permission_groups:h.ttl_token'}
                                            required={true}
                                            value={outputObject?.ttlToken}
                                            vMin={2}
                                            vMax={64}
                                            typeCallback={'number'}
                                        />
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <InputFormRest
                                            stateName={'accountExpiration'}
                                            callback={updateCallback}
                                            stateObjectState={permissionGroupStatus.accountExpiration}
                                            typeField={'text'}
                                            displayFieldName={'permission_groups:h.password_expiration'}
                                            required={true}
                                            value={outputObject?.accountExpiration}
                                            vMin={1}
                                            vMax={64}
                                            typeCallback={'number'}
                                        />
                                    </GridItem>
                                    <GridItem xs={12}></GridItem>
                                </GridContainer>
                            </GridItem>
                            <GridItem xs={8}>
                                <UserPermissionGroupAssignment
                                    checkedElements={props.checkedElements}
                                    setCheckedElements={props.setCheckedElements}
                                    id={props.id}
                                />
                            </GridItem>
                        </GridContainer>
                    )}
                </CardBody>
                <CardFooter>
                    <GridContainer>
                        <GridItem xs={10} />
                        <GridItem xs={2}>
                            <CustomTextButtom
                                size={'lg'}
                                color={'primary'}
                                callback={(): void => {
                                    savePermissionGroup(outputObject);
                                }}
                                callbackParam={{}}
                                label={'general:common.save'}
                            />
                        </GridItem>
                    </GridContainer>
                </CardFooter>
            </Card>
        </React.Fragment>
    );
};
